import { inject, Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ModalService } from '@shared/components/modal-list/modal-list.service';
import { ModalConfirmComponent } from '@shared/components/modal-confirm/modal-confirm.component';

export interface ModalConfirmOptions {
  title: string;
  text: string;
  confirmButtonText?: string;
  cancelButtonText?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ModalConfirmService {
  private readonly modalService = inject(ModalService);

  private confirm = new Subject<{ confirmed: boolean }>();

  readonly MODAL_CONFIRM_ID = 'modal-confirm';

  open(options: ModalConfirmOptions): Observable<{ confirmed: boolean }> {
    this.modalService.addModal({
      component: ModalConfirmComponent,
      id: this.MODAL_CONFIRM_ID,
      disableClose: false,
      hasCloseButton: true,
      title: '',
      width: 430,
      data: {
        title: options.title,
        text: options.text,
        confirmButtonText: options.confirmButtonText,
        cancelButtonText: options.cancelButtonText,
        confirm: () => {
          this.confirm.next({ confirmed: true });
          this.modalService.close([this.MODAL_CONFIRM_ID]);
        },
        close: () => {
          this.confirm.next({ confirmed: false });
          this.modalService.close([this.MODAL_CONFIRM_ID]);
        },
      },
    });
    return this.confirm.asObservable();
  }
}
